import { baseUrl } from "@/config";
import axios from "axios";
import { Message, Alert } from 'element-ui';
import bus from "@/utils/bus.js";
import qs from "qs";
import { getUserCountryCode } from "@/utils/judgeUseGoogle.js";
import { buildClientSeal } from "@/utils/clientSeal";

const isMobile = window.innerWidth < 950;
const instance = axios.create({
    baseURL: baseUrl,
    timeout: 30000,
    methods: 'POST',
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'DeviceType': isMobile?'H5':'Web',
		'AppVersion': '1.7.10',
    },
    // 携带凭证
    withCredentials: false,
    // 返回数据类型
    responseType: 'json'
});


// 辅助函数：从响应头中获取 token
function getHeaderToken(headers, key) {
    if (!headers) return null;
    
    // 尝试多种方式获取 token
    const lowerKey = key.toLowerCase();
    const upperKey = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
    
    // 直接访问
    let token = headers[key] || 
                headers[lowerKey] || 
                headers[upperKey] ||
                headers[key.toLowerCase()] ||
                headers[key.toUpperCase()];
    
    // 如果直接访问失败，尝试使用 get 方法
    if (!token && headers.get) {
        token = headers.get(key) || 
                headers.get(lowerKey) || 
                headers.get(upperKey) ||
                headers.get(key.toLowerCase()) ||
                headers.get(key.toUpperCase());
    }
    
    return token || null;
}

// 请求拦截器
instance.interceptors.request.use(function(config) {
    // 在发送请求之前做些什么
    config.headers.token = localStorage.getItem('token')
    config.headers.refreshToken = localStorage.getItem('refreshToken')

    const clientSeal = buildClientSeal();
    if (clientSeal) {
        config.headers['X-Client-Seal'] = clientSeal;
    }

    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});


// 添加响应拦截器
instance.interceptors.response.use(function(response) {
    // 2xx 范围内的状态码都会触发该函数。
    
    // 检查响应头中是否有新的 token 或 refreshToken，并更新
    const responseHeaders = response.headers;
    
    // 尝试多种方式获取 token（包括直接访问和通过 get 方法）
    let newToken = null;
    let newRefreshToken = null;
    
    // 尝试直接访问
    if (responseHeaders) {
        newToken = responseHeaders.token || 
                  responseHeaders.Token || 
                  responseHeaders['token'] ||
                  (responseHeaders.get && responseHeaders.get('token')) ||
                  (responseHeaders.get && responseHeaders.get('Token'));
        
        newRefreshToken = responseHeaders.refreshtoken || 
                        responseHeaders.RefreshToken || 
                        responseHeaders.refreshToken ||
                        responseHeaders['refreshtoken'] ||
                        (responseHeaders.get && responseHeaders.get('refreshtoken')) ||
                        (responseHeaders.get && responseHeaders.get('RefreshToken')) ||
                        (responseHeaders.get && responseHeaders.get('refreshToken'));
    }
    
    // 如果直接访问失败，使用辅助函数
    if (!newToken) {
        newToken = getHeaderToken(responseHeaders, 'token') || getHeaderToken(responseHeaders, 'Token');
    }
    if (!newRefreshToken) {
        newRefreshToken = getHeaderToken(responseHeaders, 'refreshtoken') || 
                         getHeaderToken(responseHeaders, 'RefreshToken') || 
                         getHeaderToken(responseHeaders, 'refreshToken');
    }
    
    // 更新 localStorage 中的 token
    if (newToken) {
        localStorage.setItem('token', newToken);
    }
    if (newRefreshToken) {
        localStorage.setItem('refreshToken', newRefreshToken);
    }
    
    // 对响应数据做点什么
    if (response.data.code == 200 || response.data.success || response.data.client_token) {
        return response.data
    } else {

        // 商家不在运营时间
        if (response.data.code == "50030") {
            Alert('The shop is closed now, please select the delivery time after the shop opens.?', 'Warning', {
                confirmButtonText: 'Confirm',
                center: true,
                callback: (action) => {
                    console.log(action)
                }
            });
            Message.error('The shop is closed now, please select the delivery time after the shop opens.')
        }

        // 注册邮箱重复
        if (response.data.code == "50021") {
            Message.error('Email registered.')
        }

        // 超出派送范围
        if (response.data.code == "50022") {
            Message.error('Over_Delivery')
        }

        // 积分不足 提示
        if (response.data.code == "50023") {
            Message.error('Lack of Points')
        }

        // 手机号不存在 提示
        if (response.data.code == "50028") {
            Message.error('The phone does not exist')
        }

        // 手机号不存在 提示
        if (response.data.code == "50029") {
            Message.error('The email does not exist')
        }

        // 手机号不存在 提示
        if (response.data.code == "50032") {
            Message.error(response.data.msg)
        }

        // 优惠码不合规使用
        // if (response.data.code == "50035") {
        //     Message.error(response.data.msg)
        // }

        // 不派送某个邮编
        if (response.data.code == "50024") {
            Message.error('Merchants ban this postcode')
        }

        // 超出金额不允许添加进购物车
        // if (response.data.code == "50034") {
        //     Message.error(response.data.msg)
        // }

        if(response.data.code == 401) {
            // 401：若有新 token/refreshToken 则替换后重新发起原请求并返回结果
            const originalRequest = response.config;
            if (newToken || newRefreshToken) {
                if (newToken) {
                    originalRequest.headers.token = newToken;
                }
                if (newRefreshToken) {
                    originalRequest.headers.refreshToken = newRefreshToken;
                }
                if (!originalRequest._retry) {
                    originalRequest._retry = true;
                    console.log('[Token Refresh] 401 error, retrying request with new token', {
                        url: originalRequest.url,
                        method: originalRequest.method,
                        hasNewToken: !!newToken,
                        hasNewRefreshToken: !!newRefreshToken
                    });
                    return instance(originalRequest);
                }
            }
            // 如果没有新 token，则跳转登录页
            Message.error('Login Expired.')
            setTimeout(() => {
                bus.$emit('logout');
                localStorage.removeItem('token');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('clientId');
                location.href = "/login";
            }, 1000);
        }

        return Promise.reject(response.data);
    }
}, function(error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    try {
        const response = error.response;
        
        if (response) {
            const responseHeaders = response.headers;
            
            // 检查响应头中是否有新的 token 或 refreshToken，并更新
            const newToken = getHeaderToken(responseHeaders, 'token') || getHeaderToken(responseHeaders, 'Token');
            const newRefreshToken = getHeaderToken(responseHeaders, 'refreshtoken') || 
                                  getHeaderToken(responseHeaders, 'RefreshToken') || 
                                  getHeaderToken(responseHeaders, 'refreshToken');
            
            if (newToken) {
                const oldToken = localStorage.getItem('token');
                localStorage.setItem('token', newToken);
                console.log('[Token Refresh] Token updated (error response)', {
                    url: error.config?.url,
                    status: response.status,
                    oldToken: oldToken ? oldToken.substring(0, 20) + '...' : null,
                    newToken: newToken.substring(0, 20) + '...'
                });
            }
            if (newRefreshToken) {
                const oldRefreshToken = localStorage.getItem('refreshToken');
                localStorage.setItem('refreshToken', newRefreshToken);
                console.log('[Token Refresh] RefreshToken updated (error response)', {
                    url: error.config?.url,
                    status: response.status,
                    oldRefreshToken: oldRefreshToken ? oldRefreshToken.substring(0, 20) + '...' : null,
                    newRefreshToken: newRefreshToken.substring(0, 20) + '...'
                });
            }
            
            // 检查 response 和 response.data 是否存在
            if (response.data && response.data.code == 401) {
                // 401：若有新 token/refreshToken 则替换后重新发起原请求，并返回重试结果
                if (newToken || newRefreshToken) {
                    const originalRequest = error.config;
                    if (newToken) {
                        originalRequest.headers.token = newToken;
                    }
                    if (newRefreshToken) {
                        originalRequest.headers.refreshToken = newRefreshToken;
                    }
                    if (!originalRequest._retry) {
                        originalRequest._retry = true;
                        console.log('[Token Refresh] 401 error, retrying request with new token (error handler)', {
                            url: originalRequest.url,
                            method: originalRequest.method,
                            hasNewToken: !!newToken,
                            hasNewRefreshToken: !!newRefreshToken
                        });
                        return instance(originalRequest);
                    }
                }
                // 如果没有新 token，则跳转登录页
                Message.error('Login Expired.')
                setTimeout(() => {
                    bus.$emit('logout');
                    localStorage.removeItem('token');
                    localStorage.removeItem('refreshToken');
                    localStorage.removeItem('clientId');
                    location.href = '/login'
                }, 1000);
            } else if (response.data) {
                // 处理其他错误情况
                const errorMsg = response.data.msg || 'Request failed';
                console.error('Request failed:', errorMsg);
                Message.error(errorMsg);
            } else {
                // HTTP 状态码错误处理
                switch (response.status) {
                    case 400:
                        error.message = 'Request error';
                        Message.error('Request error');
                        break;
                    case 403:
                        error.message = 'Access denied';
                        Message.error('Access denied');
                        break;
                    case 404:
                        error.message = `Request address error: ${error.config?.url || 'unknown'}`;
                        Message.error(error.message);
                        break;
                    case 408:
                        error.message = 'Request timeout';
                        Message.error('Request timeout');
                        break;
                    case 500:
                        error.message = 'Server internal error';
                        Message.error('Server internal error');
                        break;
                    case 501:
                        error.message = 'Service not implemented';
                        Message.error('Service not implemented');
                        break;
                    case 502:
                        error.message = 'Bad Gateway';
                        Message.error('Bad Gateway');
                        break;
                    case 503:
                        error.message = 'Service Unavailable';
                        Message.error('Service Unavailable');
                        break;
                    case 504:
                        error.message = 'Gateway timeout';
                        Message.error('Gateway timeout');
                        break;
                    case 505:
                        error.message = 'HTTP version not supported';
                        Message.error('HTTP version not supported');
                        break;
                    default:
                        // 网络错误或其他情况
                        console.error('Network error:', error.message || 'Network error, please try again');
                        Message.error(error.message || 'Network error, please try again');
                }
            }
        } else {
            // 网络错误或其他情况 - 只在控制台显示
            console.error('Network error:', error.message || 'Network error, please try again');
            Message.error(error.message || 'Network error, please try again');
        }
    } catch (err) {
        console.error('Network error:', err.message || 'Network error, please try again');
        Message.error('Network error, please try again');
    }
    
    return Promise.reject(error);
});


let countryCode = '';
getUserCountryCode().then((res) => {
    countryCode = res.countryCode;
})

// CountryCode 用来标记这个用户的地区  
// 英国 GBR
// 爱尔兰 IRL


export function postGateway(params) {
    let url = params.url;
    if (params.method && params.method.toLocaleLowerCase() == 'get') {
        url += '?' + qs.stringify(params.data)
    }
    return instance({
        method: params.method ? params.method : 'POST',
        url: url,
        data: params.data,
        headers: {
            ...params.headers,
            'CountryCode': countryCode,
			'AppVersion': '1.7.10',
        }
    })
}

export function postGatewayOther(params) {
    let url = params.url;
    return instance({
        method: params.method ? params.method : 'POST',
        url: url,
        data: params.data,
        headers: {
            ...params.headers,
            'CountryCode': countryCode
        }
    })
}

// let statusCNStrs = {
//     '400': '请求错误',
//     '401': '未授权，请登录',
//     '403': '拒绝访问',
//     '404': '请求地址出错',
//     '500': '服务器内部错误',
//     '501': '服务未实现',
//     '502': '网关错误',
//     '503': '服务不可用',
//     '504': '网关超时',
//     '505': 'HTTP版本不受支持',
//     'default': '',
// }
// let statusENStrs = {
//     '400': 'Request error',
//     '401': 'Unauthorized, please login',
//     '403': 'Access denied',
//     '404': 'Error requesting address',
//     '500': 'Server internal error',
//     '501': 'Service not implemented',
//     '502': 'Bad Gateway',
//     '503': 'Service Unavailable',
//     '504': 'Gateway timeout',
//     '505': 'The HTTP version is not supported',
//     'default': '',
// }